module.exports = __webpack_public_path__ + "static/media/cuvette_rack_long.80c956eb.svg";